var mffb_config = {
/*===================================================================================*/
/*===================================================================================*/
/*================ !!! CUSTOMIZATION OF THE MALE FRONT VIEW !!!  ====================*/
/*===================================================================================*/
/*===================================================================================*/
    "mffb_1":{//male-front-head
        "hover": "Head",//info of the popup
        "url": "https://www.sparksfitness.net/collections/head",//link to any webpage
        "target": "_self",// use "_blank", "_self", or "none"
        "active": true//true/false to show/hide
    },
    "mffb_2":{//male-front-neck
        "hover": "Neck",
        "url": "https://www.sparksfitness.net/collections/neck", "target": "_self",
        "active": true
    },
    "mffb_3":{//male-front-chest
        "hover": "Chest",
        "url": "https://www.sparksfitness.net/collections/chest", "target": "_self",
        "active": true
    },
    "mffb_4":{//male-front-abdomen
        "hover": "Abdominals",
        "url": "https://www.sparksfitness.net/collections/abdominals", "target": "_self",
        "active": true
    },
    "mffb_5":{//male-front-pelvis
        "hover": "Hips",
        "url": "https://www.sparksfitness.net/collections/hips", "target": "_self",
        "active": true
    },
    "mffb_6":{//male-front-shoulder-rt
        "hover": "Shoulders",
        "url": "https://www.sparksfitness.net/collections/shoulders", "target": "_self",
        "active": true
    },
    "mffb_7":{//male-front-shoulder-lt
        "hover": "Shoulders",
        "url": "https://www.sparksfitness.net/collections/shoulders", "target": "_self",
        "active": true
    },
    "mffb_8":{//male-front-arm-rt
        "hover": "Biceps",
        "url": "https://www.sparksfitness.net/collections/biceps", "target": "_self",
        "active": true
    },
    "mffb_9":{//male-front-arm-lt
        "hover": "Biceps",
        "url": "https://www.sparksfitness.net/collections/biceps", "target": "_self",
        "active": true
    },
    "mffb_10":{//male-front-elbow-rt
        "hover": "Elbow & Joints",
        "url": "https://www.sparksfitness.net/collections/elbow-joints", "target": "_self",
        "active": true
    },
    "mffb_11":{//male-front-elbow-lt
        "hover": "Elbow & Joints",
        "url": "https://www.sparksfitness.net/collections/elbow-joints", "target": "_self",
        "active": true
    },
    "mffb_12":{//male-front-forearm-rt
        "hover": "Forearms",
        "url": "https://www.sparksfitness.net/collections/forearms", "target": "_self",
        "active": true
    },
    "mffb_13":{//male-front-forearm-lt
        "hover": "Forearms",
        "url": "https://www.sparksfitness.net/collections/forearms", "target": "_self",
        "active": true
    },
    "mffb_14":{//male-front-wrist-rt
        "hover": "Wrist",
        "url": "https://www.sparksfitness.net/collections/wrist", "target": "_self",
        "active": true
    },
    "mffb_15":{//male-front-wrist-lt
        "hover": "Wrist",
        "url": "https://www.sparksfitness.net/collections/wrist", "target": "_self",
        "active": true
    },
    "mffb_16":{//male-front-hand-rt
        "hover": "Hands",
        "url": "https://www.sparksfitness.net/collections/hands", "target": "_self",
        "active": true
    },
    "mffb_17":{//male-front-hand-lt
        "hover": "Hands",
        "url": "https://www.sparksfitness.net/collections/hands", "target": "_self",
        "active": true
    },
    "mffb_18":{//male-front-thigh-rt
        "hover": "Quads",
        "url": "https://www.sparksfitness.net/collections/quads", "target": "_self",
        "active": true
    },
    "mffb_19":{//male-front-thigh-lt
        "hover": "Quads",
        "url": "https://www.sparksfitness.net/collections/quads", "target": "_self",
        "active": true
    },
    "mffb_20":{//male-front-knee-rt
        "hover": "Knees",
        "url": "https://www.sparksfitness.net/collections/knees", "target": "_self",
        "active": true
    },
    "mffb_21":{//male-front-knee-lt
        "hover": "Knees",
        "url": "https://www.sparksfitness.net/collections/knees", "target": "_self",
        "active": true
    },
    "mffb_22":{//male-front-leg-rt
        "hover": "Shin",
        "url": "https://www.sparksfitness.net/collections/shin", "target": "_self",
        "active": true
    },
    "mffb_23":{//male-front-leg-lt
        "hover": "Shin",
        "url": "https://www.sparksfitness.net/collections/shin", "target": "_self",
        "active": true
    },
    "mffb_24":{//male-front-ankle-rt
        "hover": "Ankle",
        "url": "https://www.sparksfitness.net/collections/ankle", "target": "_self",
        "active": true
    },
    "mffb_25":{//male-front-ankle-lt
        "hover": "Ankle",
        "url": "https://www.sparksfitness.net/collections/ankle", "target": "_self",
        "active": true
    },
    "mffb_26":{//male-front-foot-rt
        "hover": "Feet",
        "url": "https://www.sparksfitness.net/collections/feet", "target": "_self",
        "active": true
    },
    "mffb_27":{//male-front-foot-lt
        "hover": "Feet",
        "url": "https://www.sparksfitness.net/collections/feet", "target": "_self",
        "active": true
    },
/*=====================================================================================*/
/*=====================================================================================*/
/*================ !!! CUSTOMIZATION OF THE FEMALE FRONT VIEW !!!  ====================*/
/*=====================================================================================*/
/*=====================================================================================*/
    "mffb_28":{//female-front-head
        "hover": "Head",
        "url": "https://www.sparksfitness.net/collections/head", "target": "_self",
        "active": true
    },
    "mffb_29":{//female-front-neck
        "hover": "Neck",
        "url": "https://www.sparksfitness.net/collections/neck", "target": "_self",
        "active": true
    },
    "mffb_30":{//female-front-chest
        "hover": "Chest",
        "url": "https://www.sparksfitness.net/collections/chest", "target": "_self",
        "active": true
    },
    "mffb_31":{//female-front-breasts
        "hover": "Chest",
        "url": "https://www.sparksfitness.net/collections/chest", "target": "_self",
        "active": true
    },
    "mffb_32":{//female-front-abdomen
        "hover": "Abdominals",
        "url": "https://www.sparksfitness.net/collections/abdominals", "target": "_self",
        "active": true
    },
    "mffb_33":{//female-front-pelvis
        "hover": "Hips",
        "url": "https://www.sparksfitness.net/collections/hips", "target": "_self",
        "active": true
    },
    "mffb_34":{//female-front-shoulder-rt
        "hover": "Shoulders",
        "url": "https://www.sparksfitness.net/collections/shoulders", "target": "_self",
        "active": true
    },
    "mffb_35":{//female-front-shoulder-lt
        "hover": "Shoulders",
        "url": "https://www.sparksfitness.net/collections/shoulders", "target": "_self",
        "active": true
    },
    "mffb_36":{//female-front-arm-rt
        "hover": "Biceps",
        "url": "https://www.sparksfitness.net/collections/biceps", "target": "_self",
        "active": true
    },
    "mffb_37":{//female-front-arm-lt
        "hover": "Biceps",
        "url": "https://www.sparksfitness.net/collections/biceps", "target": "_self",
        "active": true
    },
    "mffb_38":{//female-front-elbow-rt
        "hover": "Elbow & Joints",
        "url": "https://www.sparksfitness.net/collections/elbow-joints", "target": "_self",
        "active": true
    },
    "mffb_39":{//female-front-elbow-lt
        "hover": "Elbow & Joints",
        "url": "https://www.sparksfitness.net/collections/elbow-joints", "target": "_self",
        "active": true
    },
    "mffb_40":{//female-front-forearm-rt
        "hover": "Forearms",
        "url": "https://www.sparksfitness.net/collections/forearms", "target": "_self",
        "active": true
    },
    "mffb_41":{//female-front-forearm-lt
        "hover": "Forearms",
        "url": "https://www.sparksfitness.net/collections/forearms", "target": "_self",
        "active": true
    },
    "mffb_42":{//female-front-wrist-rt
        "hover": "Wrist",
        "url": "https://www.sparksfitness.net/collections/wrist", "target": "_self",
        "active": true
    },
    "mffb_43":{//female-front-wrist-lt
        "hover": "Wrist",
        "url": "https://www.sparksfitness.net/collections/wrist", "target": "_self",
        "active": true
    },
    "mffb_44":{//female-front-hand-rt
        "hover": "Hands",
        "url": "https://www.sparksfitness.net/collections/hands", "target": "_self",
        "active": true
    },
    "mffb_45":{//female-front-hand-lt
        "hover": "Hands",
        "url": "https://www.sparksfitness.net/collections/hands", "target": "_self",
        "active": true
    },
    "mffb_46":{//female-front-thigh-rt
        "hover": "Quads",
        "url": "https://www.sparksfitness.net/collections/quads", "target": "_self",
        "active": true
    },
    "mffb_47":{//female-front-thigh-lt
        "hover": "Quads",
        "url": "https://www.sparksfitness.net/collections/quads", "target": "_self",
        "active": true
    },
    "mffb_48":{//female-front-knee-rt
        "hover": "Knees",
        "url": "https://www.sparksfitness.net/collections/knees", "target": "_self",
        "active": true
    },
    "mffb_49":{//female-front-knee-lt
        "hover": "Knees",
        "url": "https://www.sparksfitness.net/collections/knees", "target": "_self",
        "active": true
    },
    "mffb_50":{//female-front-leg-rt
        "hover": "Shin",
        "url": "https://www.sparksfitness.net/collections/shin", "target": "_self",
        "active": true
    },
    "mffb_51":{//female-front-leg-lt
        "hover": "Shin",
        "url": "https://www.sparksfitness.net/collections/shin", "target": "_self",
        "active": true
    },
    "mffb_52":{//female-front-ankle-rt
        "hover": "Ankle",
        "url": "https://www.sparksfitness.net/collections/ankle", "target": "_self",
        "active": true
    },
    "mffb_53":{//female-front-ankle-lt
        "hover": "Ankle",
        "url": "https://www.sparksfitness.net/collections/ankle", "target": "_self",
        "active": true
    },
    "mffb_54":{//female-front-foot-rt
        "hover": "Feet",
        "url": "https://www.sparksfitness.net/collections/feet", "target": "_self",
        "active": true
    },
    "mffb_55":{//female-front-foot-lt
        "hover": "Feet",
        "url": "https://www.sparksfitness.net/collections/feet", "target": "_self",
        "active": true
    },
/*==================================================================================*/
/*==================================================================================*/
/*================ !!! CUSTOMIZATION OF THE MALE BACK VIEW !!! =====================*/
/*==================================================================================*/
/*==================================================================================*/
    "mffb_56":{//male-back-head
        "hover": "Head",
        "url": "https://www.sparksfitness.net/collections/head", "target": "_self",
        "active": true
    },
    "mffb_57":{//male-back-neck
        "hover": "Neck",
        "url": "https://www.sparksfitness.net/collections/neck", "target": "_self",
        "active": true
    },
    "mffb_58":{//male-back-back
        "hover": "Back",
        "url": "https://www.sparksfitness.net/collections/back", "target": "_self",
        "active": true
    },
    "mffb_59":{//male-back-loin
        "hover": "Lower Back",
        "url": "https://www.sparksfitness.net/collections/lower-back", "target": "_self",
        "active": true
    },
    "mffb_60":{//male-back-buttocks
        "hover": "Glutes",
        "url": "https://www.sparksfitness.net/collections/glutes", "target": "_self",
        "active": true
    },
    "mffb_61":{//male-back-shoulder-rt
        "hover": "Shoulders",
        "url": "https://www.sparksfitness.net/collections/shoulders", "target": "_self",
        "active": true
    },
    "mffb_62":{//male-back-shoulder-lt
        "hover": "Shoulders",
        "url": "https://www.sparksfitness.net/collections/shoulders", "target": "_self",
        "active": true
    },
    "mffb_63":{//male-back-arm-rt
        "hover": "Triceps",
        "url": "https://www.sparksfitness.net/collections/triceps", "target": "_self",
        "active": true
    },
    "mffb_64":{//male-back-arm-lt
        "hover": "Triceps",
        "url": "https://www.sparksfitness.net/collections/triceps", "target": "_self",
        "active": true
    },
    "mffb_65":{//male-back-elbow-rt
        "hover": "Elbow & Joints",
        "url": "https://www.sparksfitness.net/collections/elbow-joints", "target": "_self",
        "active": true
    },
    "mffb_66":{//male-back-elbow-lt
        "hover": "Elbow & Joints",
        "url": "https://www.sparksfitness.net/collections/elbow-joints", "target": "_self",
        "active": true
    },
    "mffb_67":{//male-back-forearm-rt
        "hover": "Forearms",
        "url": "https://www.sparksfitness.net/collections/forearms", "target": "_self",
        "active": true
    },
    "mffb_68":{//male-back-forearm-lt
        "hover": "Forearms",
        "url": "https://www.sparksfitness.net/collections/forearms", "target": "_self",
        "active": true
    },
    "mffb_69":{//male-back-wrist-rt
        "hover": "Wrist",
        "url": "https://www.sparksfitness.net/collections/wrist", "target": "_self",
        "active": true
    },
    "mffb_70":{//male-back-wrist-lt
        "hover": "Wrist",
        "url": "https://www.sparksfitness.net/collections/wrist", "target": "_self",
        "active": true
    },
    "mffb_71":{//male-back-hand-rt
        "hover": "Hands",
        "url": "https://www.sparksfitness.net/collections/hands", "target": "_self",
        "active": true
    },
    "mffb_72":{//male-back-hand-lt
        "hover": "Hands",
        "url": "https://www.sparksfitness.net/collections/hands", "target": "_self",
        "active": true
    },
    "mffb_73":{//male-back-hamstring-rt
        "hover": "Hamstrings",
        "url": "https://www.sparksfitness.net/collections/hamstrings", "target": "_self",
        "active": true
    },
    "mffb_74":{//male-back-hamstring-lt
        "hover": "Hamstrings",
        "url": "https://www.sparksfitness.net/collections/hamstrings", "target": "_self",
        "active": true
    },
    "mffb_75":{//male-back-knee-rt
        "hover": "Knees",
        "url": "https://www.sparksfitness.net/collections/knees", "target": "_self",
        "active": true
    },
    "mffb_76":{//male-back-knee-lt
        "hover": "Knees",
        "url": "https://www.sparksfitness.net/collections/knees", "target": "_self",
        "active": true
    },
    "mffb_77":{//male-back-calf-rt
        "hover": "Calf",
        "url": "https://www.sparksfitness.net/collections/calf", "target": "_self",
        "active": true
    },
    "mffb_78":{//male-back-calf-lt
        "hover": "Calf",
        "url": "https://www.sparksfitness.net/collections/calf", "target": "_self",
        "active": true
    },
    "mffb_79":{//male-back-ankle-rt
        "hover": "Ankle",
        "url": "https://www.sparksfitness.net/collections/ankle", "target": "_self",
        "active": true
    },
    "mffb_80":{//male-back-ankle-lt
        "hover": "Ankle",
        "url": "https://www.sparksfitness.net/collections/ankle", "target": "_self",
        "active": true
    },
    "mffb_81":{//male-back-sole-rt
        "hover": "Sole",
        "url": "https://www.sparksfitness.net/collections/sole", "target": "_self",
        "active": true
    },
    "mffb_82":{//male-back-sole-lt
        "hover": "Sole",
        "url": "https://www.sparksfitness.net/collections/sole", "target": "_self",
        "active": true
    },
    "mffb_83":{//male-back-foot-rt
        "hover": "Feet",
        "url": "https://www.sparksfitness.net/collections/feet", "target": "_self",
        "active": true
    },
    "mffb_84":{//male-back-foot-lt
        "hover": "Feet",
        "url": "https://www.sparksfitness.net/collections/feet", "target": "_self",
        "active": true
    },
/*====================================================================================*/
/*====================================================================================*/
/*================ !!! CUSTOMIZATION OF THE FEMALE BACK VIEW !!! =====================*/
/*====================================================================================*/
/*====================================================================================*/
    "mffb_85":{//female-back-head
        "hover": "Head",
        "url": "https://www.sparksfitness.net/collections/head", "target": "_self",
        "active": true
    },
    "mffb_86":{//female-back-neck
        "hover": "Neck",
        "url": "https://www.sparksfitness.net/collections/neck", "target": "_self",
        "active": true
    },
    "mffb_87":{//female-back-back
        "hover": "Back",
        "url": "https://www.sparksfitness.net/collections/back", "target": "_self",
        "active": true
    },
    "mffb_88":{//female-back-loin
        "hover": "Lower Back",
        "url": "https://www.sparksfitness.net/collections/lower-back", "target": "_self",
        "active": true
    },
    "mffb_89":{//female-back-buttocks
        "hover": "Glutes",
        "url": "https://www.sparksfitness.net/collections/glutes", "target": "_self",
        "active": true
    },
    "mffb_90":{//female-back-shoulder-rt
        "hover": "Shoulders",
        "url": "https://www.sparksfitness.net/collections/shoulders", "target": "_self",
        "active": true
    },
    "mffb_91":{//female-back-shoulder-lt
        "hover": "Shoulders",
        "url": "https://www.sparksfitness.net/collections/shoulders", "target": "_self",
        "active": true
    },
    "mffb_92":{//female-back-arm-rt
        "hover": "Triceps",
        "url": "https://www.sparksfitness.net/collections/triceps", "target": "_self",
        "active": true
    },
    "mffb_93":{//female-back-arm-lt
        "hover": "Triceps",
        "url": "https://www.sparksfitness.net/collections/triceps", "target": "_self",
        "active": true
    },
    "mffb_94":{//female-back-elbow-rt
        "hover": "Elbow & Joints",
        "url": "https://www.sparksfitness.net/collections/elbow-joints", "target": "_self",
        "active": true
    },
    "mffb_95":{//female-back-elbow-lt
        "hover": "Elbow & Joints",
        "url": "https://www.sparksfitness.net/collections/elbow-joints", "target": "_self",
        "active": true
    },
    "mffb_96":{//female-back-forearm-rt
        "hover": "Forearms",
        "url": "https://www.sparksfitness.net/collections/forearms", "target": "_self",
        "active": true
    },
    "mffb_97":{//female-back-forearm-lt
        "hover": "Forearms",
        "url": "https://www.sparksfitness.net/collections/forearms", "target": "_self",
        "active": true
    },
    "mffb_98":{//female-back-wrist-rt
        "hover": "Wrist",
        "url": "https://www.sparksfitness.net/collections/wrist", "target": "_self",
        "active": true
    },
    "mffb_99":{//female-back-wrist-lt
        "hover": "Wrist",
        "url": "https://www.sparksfitness.net/collections/wrist", "target": "_self",
        "active": true
    },
    "mffb_100":{//female-back-hand-rt
        "hover": "Hands",
        "url": "https://www.sparksfitness.net/collections/hands", "target": "_self",
        "active": true
    },
    "mffb_101":{//female-back-hand-lt
        "hover": "Hands",
        "url": "https://www.sparksfitness.net/collections/hands", "target": "_self",
        "active": true
    },
    "mffb_102":{//female-back-hamstring-rt
        "hover": "Hamstrings",
        "url": "https://www.sparksfitness.net/collections/hamstrings", "target": "_self",
        "active": true
    },
    "mffb_103":{//female-back-hamstring-lt
        "hover": "Hamstrings",
        "url": "https://www.sparksfitness.net/collections/hamstrings", "target": "_self",
        "active": true
    },
    "mffb_104":{//female-back-knee-rt
        "hover": "Knees",
        "url": "https://www.sparksfitness.net/collections/knees", "target": "_self",
        "active": true
    },
    "mffb_105":{//female-back-knee-lt
        "hover": "Knees",
        "url": "https://www.sparksfitness.net/collections/knees", "target": "_self",
        "active": true
    },
    "mffb_106":{//female-back-calf-rt
        "hover": "Calf",
        "url": "https://www.sparksfitness.net/collections/calf", "target": "_self",
        "active": true
    },
    "mffb_107":{//female-back-calf-lt
        "hover": "Calf",
        "url": "https://www.sparksfitness.net/collections/calf", "target": "_self",
        "active": true
    },
    "mffb_108":{//female-back-ankle-rt
        "hover": "Ankle",
        "url": "https://www.sparksfitness.net/collections/ankle", "target": "_self",
        "active": true
    },
    "mffb_109":{//female-back-ankle-lt
        "hover": "Ankle",
        "url": "https://www.sparksfitness.net/collections/ankle", "target": "_self",
        "active": true
    },
    "mffb_110":{//female-back-sole-rt
        "hover": "Sole",
        "url": "https://www.sparksfitness.net/collections/sole", "target": "_self",
        "active": true
    },
    "mffb_111":{//female-back-sole-lt
        "hover": "Sole",
        "url": "https://www.sparksfitness.net/collections/sole", "target": "_self",
        "active": true
    },
    "mffb_112":{//female-back-foot-rt
        "hover": "Feet",
        "url": "https://www.sparksfitness.net/collections/feet", "target": "_self",
        "active": true
    },
    "mffb_113":{//female-back-foot-lt
        "hover": "Feet",
        "url": "https://www.sparksfitness.net/collections/feet", "target": "_self",
        "active": true
    }
};